import { put, takeEvery } from 'redux-saga/effects';
import { CREATE_BY_CAMPAIGN_ADMIN_SUCCESS } from '../users/actions';
import { getList } from './actions';

export function* createByCampaignAdminSuccess() {
  yield takeEvery([CREATE_BY_CAMPAIGN_ADMIN_SUCCESS], function* (action) {
    yield put(getList(action.data.ownerId, 1));
  });
}
